// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__7Ygjg","title-hero":"hero_title-hero__pQ5hJ"};